import type { MaterialSymbolIcon } from '@gravitate-js/excalibrr'
import type { MatchStatus } from '../../../../api/useSupplierReconciliation/types/common'

interface StatusConfigItem {
  display: string
  icon: MaterialSymbolIcon
  tagProps: {
    error?: boolean
    warning?: boolean
    success?: boolean
    theme2?: boolean
  }
}

type StatusConfig = {
  [key in MatchStatus]: StatusConfigItem
}

export const MATCH_STATUS_CONFIG: StatusConfig = {
  unapproved: {
    display: 'Unapproved',
    icon: 'handshake',
    tagProps: {
      warning: true,
    },
  },
  unmatched: {
    display: 'Unmatched',
    icon: 'content_paste_search',
    tagProps: {
      error: true,
    },
  },
  approved: {
    display: 'Approved',
    icon: 'check_circle',
    tagProps: {
      success: true,
    },
  },
  hold: {
    display: 'On Hold',
    icon: 'schedule',
    tagProps: {
      warning: true,
    },
  },
  unmapped: {
    display: 'Unmapped',
    icon: 'help_center',
    tagProps: {
      error: true,
    },
  },
  void: {
    display: 'Voided',
    icon: 'cancel',
    tagProps: {
      error: true,
    },
  },
  unvoided: {
    display: 'Unvoided',
    icon: 'refresh',
    tagProps: {
      // success: true,
    },
  },
}
